// ----------------------------------------------------------------------

export const status = ["Active", "Pending", "Rejected"];
